import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { spacing } = theme.busbud;

  return {
    duration: {
      verticalAlign: "top" // Prevents extra space caused by inline.
    },
    info: {
      marginTop: spacing(0.5)
    },
    description: {
      overflowWrap: "anywhere"
    },
    logo: {
      width: "fit-content"
    }
  };
});
